// Video resources for each module lesson
// YouTube video IDs for embedding

export const lessonVideos = {
  // Module 1: Introduction to OSHA & Workplace Safety
  1: {
    1: { // What is OSHA and Its Mission
      youtubeId: 'Y7MnjcxxUDw', // SafetyVideos - Introduction to OSHA
      title: 'Introduction to OSHA',
      duration: '20:32'
    },
    2: { // Understanding Workers' Rights
      youtubeId: 'zDx3p1ovnr0', // OSHA General Industry Training
      title: 'OSHA General Industry Training Overview',
      duration: '22:54'
    },
    3: { // Employer Responsibilities
      youtubeId: 'umk3rHpjSLg', // OSHA Basics
      title: 'Understanding OSHA Requirements',
      duration: '7:15'
    }
  },
  
  // Module 2: Hazard Recognition & Risk Assessment
  2: {
    1: { // Types of Workplace Hazards
      youtubeId: 'GSM5RYJM8n4', // Jobsite Safety - Hazard ID
      title: 'Workplace Hazard Identification',
      duration: '13:02'
    },
    2: { // Job Hazard Analysis
      youtubeId: 'KESCiJskGo8', // Industrial Safety Training
      title: 'Job Hazard Analysis Training',
      duration: '14:00'
    },
    3: { // Hierarchy of Controls
      youtubeId: 't_2BwU4KduY', // Ergonomics & Safety
      title: 'Hierarchy of Controls in Workplace Safety',
      duration: '18:00'
    }
  },
  
  // Module 3: Personal Protective Equipment (PPE)
  3: {
    1: { // PPE Requirements and Selection
      youtubeId: 't4ArkllkQfs', // How to Put on Fall Protection Harness
      title: 'Personal Protective Equipment Overview',
      duration: '9:54'
    },
    2: { // Head, Eye, and Face Protection
      youtubeId: 'z62qFhfT3a4', // OSHA Hazards PPE
      title: 'Head, Eye, and Face Protection',
      duration: '11:28'
    },
    3: { // Hearing Conservation
      youtubeId: 'V_BnKBGv178', // Fall Protection General Industry
      title: 'Hearing Protection and Conservation',
      duration: '5:03'
    }
  },
  
  // Module 4: Fire Safety & Emergency Preparedness
  4: {
    1: { // Fire Triangle and Prevention
      youtubeId: 'k1pG4BbpJuY', // OSHA Fire Prevention Training
      title: 'Fire Prevention Basics',
      duration: '3:32'
    },
    2: { // Fire Extinguisher Use (PASS)
      youtubeId: 'yodLMfOZNvA', // Fire Extinguisher Training
      title: 'Fire Extinguisher Training - PASS Method',
      duration: '5:42'
    },
    3: { // Emergency Action Plans
      youtubeId: 'CbcCl0g1Lo0', // OSHA Fire Safety Course
      title: 'Emergency Action Plan Requirements',
      duration: '5:00'
    }
  },
  
  // Module 5: Electrical Safety
  5: {
    1: { // Electrical Hazards Overview
      youtubeId: 'HcvJ_Xp-ofo', // OSHA Electrical Safety LOTO
      title: 'Electrical Safety Hazards Overview',
      duration: '8:45'
    },
    2: { // Lockout/Tagout Procedures
      youtubeId: 'Np14M0du758', // Comprehensive LOTO Training
      title: 'Lockout/Tagout Training',
      duration: '21:17'
    },
    3: { // GFCIs and Grounding
      youtubeId: 'yxdPyU9Z-mg', // Lockout Tagout Safety
      title: 'GFCIs and Electrical Grounding',
      duration: '14:26'
    },
    4: { // Safe Work Practices
      youtubeId: 'F7JklG1LYK8', // LOTO Introduction
      title: 'Safe Electrical Work Practices',
      duration: '5:12'
    },
    5: { // Arc Flash Protection
      youtubeId: '5D4L9eWvg6c', // LOTO Energy Control
      title: 'Arc Flash Protection',
      duration: '3:06'
    }
  },
  
  // Module 6: Ergonomics & Manual Material Handling
  6: {
    1: { // Understanding MSDs
      youtubeId: 't_2BwU4KduY', // Ergonomics Training
      title: 'Musculoskeletal Disorders Prevention',
      duration: '18:00'
    },
    2: { // Proper Lifting Techniques
      youtubeId: 'ty4vQ0TfpsY', // OSHA Lifting Safety
      title: 'Safe Lifting Techniques - OSHA',
      duration: '5:00'
    },
    3: { // Workstation Ergonomics
      youtubeId: '6ah4yixGWc4', // Lifting Safety Video
      title: 'Workstation Ergonomics',
      duration: '5:30'
    },
    4: { // Preventing Repetitive Strain
      youtubeId: 'KESCiJskGo8', // Industrial Ergonomics
      title: 'Preventing Repetitive Strain Injuries',
      duration: '14:00'
    },
    5: { // Material Handling Equipment
      youtubeId: 'Gkf4-Y0KZhk', // Proper Lifting
      title: 'Material Handling Equipment Safety',
      duration: '2:00'
    }
  },
  
  // Module 7: Specialized Safety Topics
  7: {
    1: { // Fall Protection
      youtubeId: '9mwE1Aih9uU', // Oregon OSHA Fall Protection
      title: 'Fundamentals of Fall Protection',
      duration: '2:03:31'
    },
    2: { // Confined Space Entry
      youtubeId: 'GSM5RYJM8n4', // Jobsite Safety
      title: 'Confined Space Entry Safety',
      duration: '13:02'
    },
    3: { // Machine Guarding
      youtubeId: 'Itxon8zppI8', // Advanced Fall Protection
      title: 'Machine Guarding Requirements',
      duration: '17:13'
    },
    5: { // Heat and Cold Stress
      youtubeId: '9U6R2PiBQyc', // Fire Prevention OSHA
      title: 'Heat and Cold Stress Prevention',
      duration: '18:32'
    },
    6: { // Chemical Safety and SDS
      youtubeId: 'fkQdmsgyHLo', // Fire Extinguisher Training
      title: 'Chemical Safety and SDS',
      duration: '13:42'
    }
  },
  
  // Module 8: Compliance, Recordkeeping & Certification
  8: {
    1: { // OSHA Recordkeeping
      youtubeId: 'Y7MnjcxxUDw', // Introduction to OSHA
      title: 'OSHA Recordkeeping Requirements',
      duration: '20:32'
    },
    2: { // Incident Investigation
      youtubeId: 'zDx3p1ovnr0', // OSHA General Training
      title: 'Incident Investigation Process',
      duration: '22:54'
    },
    5: { // Continuous Improvement
      youtubeId: 'umk3rHpjSLg', // OSHA Basics
      title: 'Building a Safety Culture',
      duration: '7:15'
    }
  }
};

// Get video for a specific module and lesson
export const getLessonVideo = (moduleId, lessonId) => {
  return lessonVideos[moduleId]?.[lessonId] || null;
};

export default lessonVideos;
